import Http from "../http";
import {
  ATMPair,
  TradeStrategy,
  ATMOrderPayment,
  RateItem,
  TradeSide,
  TradeOrder,
  TradeOrdersParams,
  ATMPairMarketInfo,
  C2COrder,
  C2COrderParams,
  C2COffer,
  C2CHfoxOrderParams,
  FiatAsset,
  CreateReservationPaylaod
} from "../models/market";
import { Asset } from "../models/wallet/mixin";

export default function(http: Http) {
  return {
    getRate(): Promise<RateItem> {
      return http.get("/currencies");
    },

    getMarketInfoBySymbol(symbol: string): Promise<ATMPairMarketInfo> {
      return http.get("/atm/market", { params: { symbol } });
    },

    getATMPairs(): Promise<ATMPair[]> {
      return http.get("/atm/pairs");
    },

    putATMOrder(data: {
      base_symbol: string;
      quote_asset_id: string;
      quote_quantity: string;
    }): Promise<ATMOrderPayment> {
      return http.post("/atm/orders", { data });
    },

    putOrder(data: {
      pair: string;
      side: TradeSide;
      quantity: string;
      strategy: TradeStrategy;
      price_change?: string;
      price_limit?: string;
    }): Promise<TradeOrder> {
      return http.post("/atm/orders", { data });
    },

    requestPayOrder(id: string) {
      return http.get(`/atm/orders/${id}/pay`);
    },

    requestCancelOrder(id: string) {
      return http.delete(`/atm/orders/${id}`);
    },

    getTradeOrders(params: TradeOrdersParams): Promise<TradeOrder[]> {
      return http.get("/atm/orders", { params });
    },

    validateDepth(data) {
      return http.post("/atm/depth/validation", { data });
    },

    preOrder(data, cancelToken) {
      return http.post("/atm/preorder", { data, cancelToken });
    },

    getTradeOrderById(id: string): Promise<TradeOrder> {
      return http.get(`/atm/orders/${id}`);
    },

    putC2COrder(data: C2COrderParams): Promise<C2COrder> {
      return http.post("/c2c/orders", { data });
    },

    putC2CHfoxOrder(data: C2CHfoxOrderParams): Promise<C2COrder> {
      return http.post("/c2c/hfox/orders", { data });
    },

    getC2COrderById(id: string): Promise<C2COrder> {
      return http.get(`/c2c/orders/${id}`);
    },

    getC2COrders(params): Promise<C2COrder[]> {
      return http.get("/c2c/orders", { params });
    },

    setC2COrderPaid(id: string, payway: string): Promise<C2COrder> {
      return http.put(`/c2c/orders/${id}/paid`, { data: { payway } });
    },

    cancelC2COrder(id: string): Promise<C2COrder> {
      return http.delete(`/c2c/orders/${id}`);
    },

    getC2COffer(fait: string, asset: string): Promise<C2COffer> {
      return http.get("/c2c/offer", { params: { fait, asset } });
    },

    getC2COffers(): Promise<C2COffer[]> {
      return http.get("/c2c/offers");
    },

    getKlineThumbnail() {
      return http.get("/trade/kline/thumbnail");
    },

    getFiatPairs(): Promise<FiatAsset[]> {
      return http.get("/trade/fiatpairs");
    },

    createWyreReservations(opts: CreateReservationPaylaod) {
      return http.post("/wyre/reservations", { data: opts });
    },

    getWyreOrders(opts: { offset: number; limit: number }) {
      return http.get("/wyre/orders", { params: opts });
    },

    getWyreOrder(id: string) {
      return http.get(`/wyre/orders/${id}`);
    },

    getWyreSupportedCrypto(): Promise<Asset[]> {
      return http.get(`/wyre/supportedcryptocurrencies`);
    },

    getWyreSupportedFiat(): Promise<string[]> {
      return http.get(`/wyre/supportedfiatcurrencies`);
    },

    getWyreSupportedMethod(): Promise<string[]> {
      return http.get("/wyre/supportedpaymentmethods");
    },

    getWyreSupportedCountry() {
      return http.get("/wyre/supportedcountries");
    },

    getWyreQuotations(opts) {
      return http.post("/wyre/quotations", { data: opts });
    }
  };
}
